/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBubbles = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M18 8a4 4 0 1 0-8 0 4 4 0 0 0 8 0zm2 0A6 6 0 1 1 8 8a6 6 0 0 1 12 0zM8 17a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm10 1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm2 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z" />
        <path d="M11 8.5A3.502 3.502 0 0 1 14.5 5h.5v2h-.5A1.503 1.503 0 0 0 13 8.5V9h-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgBubbles as Bubbles };
